import React from "react";
import "./agents.scss";

const Agents = () => {
  return (
    <>
      <div className='journew'>

      <section className="main_agents">
        <div className="custom-container">
          <div className="innner_agents">
            <h2>Prediction Markets Built for AI Agents</h2>
            <p>
              Rain provides the first machine-readable infrastructure
              specifically engineered for AI agents. Our modular SDK gives you
              total protocol autonomy to launch public or private markets,
              manage AI Oracle resolutions, and own your forecasting ecosystem
              from day one
            </p>
           <div className="logo-slider">
  <div className="logo-track">
    <img src="/assets/openclaw.svg" />
    <img src="/assets/claude.svg" />
    <img src="/assets/manus.svg" />
    <img src="/assets/hermes.svg" />
    <img src="/assets/code.svg" />
    <img src="/assets/devin.svg" />
    <img src="/assets/auto.svg" />
    <img src="/assets/replit.svg" />
    <img src="/assets/loveable.svg" />
    <img src="/assets/basefour.svg" />

    {/* duplicate for smooth loop */}
    <img src="/assets/openclaw.svg" />
    <img src="/assets/claude.svg" />
    <img src="/assets/manus.svg" />
    <img src="/assets/hermes.svg" />
    <img src="/assets/code.svg" />
    <img src="/assets/devin.svg" />
    <img src="/assets/auto.svg" />
    <img src="/assets/replit.svg" />
    <img src="/assets/loveable.svg" />
    <img src="/assets/basefour.svg" />
  </div>
</div>
          </div>
        </div>
      </section>
      </div>
    </>
  );
};

export default Agents;
